export default __webpack_public_path__ + "static/media/fill.7667cba0.png";